//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import testimonialsModal from "~/components/modal/testimonals-modal";
export default {
  layout: "nav-fixed",
  components: {
    testimonialsModal,
  },
  data() {
    return {
      searchQuery: "",
      selectedUser: {},
      modalVisible: false,
      currentPage: null,
      pageSize: 16,
      filters: {
        year: null,
        month: null,
      },
      metadata: {
        meta_title: "",
        meta_description: "",
        keywords: "",
        share_image_alt: "",
        share_image_url: "",
        prevent_indexing: false,
        // preventIndexing: "",
      },
    };
  },
  // head() {
  //   return {
  //     title: this.metadata.meta_title,
  //     meta: [
  //       {
  //         name: "description",
  //         hid: "description",
  //         content: this.metadata.meta_description,
  //       },
  //       {
  //         name: "og:description",
  //         hid: "og:description",
  //         content: this.metadata.meta_description,
  //       },
  //       { name: "keywords", hid: "keywords", content: this.metadata.keywords },
  //       {
  //         name: "shareImageAlt",
  //         hid: "shareImage",
  //         content: this.metadata.share_image_alt,
  //       },
  //       {
  //         name: "shareImage",
  //         hid: "shareImage",
  //         content: this.metadata.share_image_url,
  //       },
  //       {
  //         name: "preventindex",
  //         hid: "preventindex",
  //         content: this.metadata.prevent_indexing,
  //       },
  //     ],
  //   };
  // },
  mounted() {
    this.$store.commit("family-passion/CLEAR_TESTIMONIALS");
    this.currentPage =
      typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1;
    this.filters = {
      year:
        typeof this.$route.query.year != "undefined"
          ? this.$route.query.year
          : "",
      month:
        typeof this.$route.query.month != "undefined"
          ? this.$route.query.month
          : "",
    };

    this.fetchData();
  },
  computed: {
    pageData() {
      if (this.$store.state["family-passion"].testimonials != null) {
        this.metadata =
          this.$store.state["family-passion"].testimonials.results.seo;
        return this.$store.state["family-passion"].testimonials.results;
      }
    },
    totalItems() {
      if (this.$store.state["family-passion"].testimonials != null) {
        return this.$store.state["family-passion"].testimonials.total_items;
      }
    },
    monthList() {
      if (this.filters.year != "") {
        return Array.from({ length: 12 }, (_, i) => i + 1);
      } else {
        this.filters.month = "";
        return ["MONTH"];
      }
    },
  },
  watch: {
    "filters.year": function (newVal, oldVal) {
      if (newVal != "undefined") {
        this.fetchData();
        this.searchQuery = "";
        this.$store.commit("family-passion/CLEAR_TESTIMONIALS");
      }
    },
    "filters.month": function (newVal, oldVal) {
      if (newVal != "undefined") {
        this.fetchData();
        this.searchQuery = "";
        this.$store.commit("family-passion/CLEAR_TESTIMONIALS");
      }
    },
    currentPage: function (newVal, oldVal) {
      if (newVal) {
        window.scrollTo(0, 0);
        this.fetchData();
        this.$store.commit("family-passion/CLEAR_TESTIMONIALS");
      }
    },
    searchQuery: function (newVal, oldVal) {
      this.currentPage = 1;
      let data = {
        size: 16,
        filteredText: newVal.toLowerCase(),
        page: this.currentPage,
        size: this.pageSize,
        year: this.filters.year,
        month: this.filters.month,
      };
      this.fetchFilteredItems(data);
    },
  },
  methods: {
    fetchData() {
      let data = {
        size: this.pageSize,
        page: this.currentPage,
        year: this.filters.year,
        month: this.filters.month,
        filteredText: this.searchQuery,
      };
      this.$router.push({ path: "/dilmah-family/testimonials", query: data });
      this.$store.dispatch("family-passion/getTestimonials", data);
    },
    useMoment(testimonialDate) {
      if (testimonialDate != "") {
        return this.$moment(testimonialDate).format("MMM DD, YYYY");
      }
    },
    changeEv() {
      this.currentPage = 1;
    },
    sendInfo(item) {
      this.selectedUser = item;
      this.$bvModal.show("testimonialsModal");
    },
    fetchFilteredItems(data) {
      this.$store.dispatch("family-passion/getTestimonials", data);
      this.$router.push({ path: "/dilmah-family/testimonials", query: data });
    },
  },
};
